import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import LevelDropdown from './levelDropdown.js';
import CategoryDropdown from './categoryDropdown.js';
import ProtocolDropdown from './protocolDropdown.js';
import AnnexesDropdown from './annexesDropdown.js';
import StagesDropdown from './stagesDropdown.js';
import RefreshButton from './refreshButton.js';
import InfoTooltip from '../infoTooltip/infoTooltip.js';

import Slide from '@material-ui/core/Slide';
import Divider from '@material-ui/core/Divider';
import { _ } from '../../functions/translator.js';
import CustomCardTypesButton from './customCardTypesButton.js';
import { FilterActions } from '../../constants/constants.js';
import { filterChange } from '../../actions/index';

function FiltersSet() {
  const dispatch = useDispatch();

  const {
    itemsSwitch,
    popUpMenu,
    popUpMessage,
    customCards,
    userData,
    customcardTypes,
  } = useSelector((state) => ({
    itemsSwitch: state.switches.items,
    popUpMenu: state.popUpMenu,
    popUpMessage: state.popUpMessage,
    customCards: state.projectData.customcards,
    userData: state.userData,
    customcardTypes: state.customcardTypes,
  }));
  let userActiveModules = userData.attributes.active_modules
    ? userData.attributes.active_modules.split(', ')
    : [];
  const [activeCustomcardTypes, setActiveCustomcardTypes] = useState(userActiveModules.length > 0 ? [userActiveModules[0]] : []);

  const handleCustomcardTypeChange = (customcardType) => {
    let newActiveTypes;

    if (activeCustomcardTypes.includes(customcardType)) {
      if (activeCustomcardTypes.length === 1) {
        return
      }
      newActiveTypes = activeCustomcardTypes.filter(type => type !== customcardType);
    } else {
      newActiveTypes = [...activeCustomcardTypes, customcardType];
    }
    dispatch(filterChange(FilterActions.CUSTOMCARD_TYPES, newActiveTypes));
    setActiveCustomcardTypes(newActiveTypes);

    if (newActiveTypes.length === 0 ) {
      dispatch(filterChange(FilterActions.CUSTOMCARD, []));
      return
    }

    let selectedCustomcardIds = Object.entries(customCards)
      .filter(([_, value]) => newActiveTypes.includes(value.attributes.type_))
      .map(([key]) => key);

    if (selectedCustomcardIds.length === 0) {
      dispatch(filterChange(FilterActions.CUSTOMCARD, null));
    } else {
      dispatch(filterChange(FilterActions.CUSTOMCARD, selectedCustomcardIds));
    }
  };

  const filterWidth = '18%';
  const filterHeight = '60%';

  return (
    <div>
      <Slide in={!popUpMessage.show && !popUpMenu.show} direction="down">
        <div className={itemsSwitch ? 'filters-card-layout filters-right card-color' : 'filters-card-layout card-color'}>
          <div className="filters-container flex-fill">
            <div style={{ width: filterWidth }}>
              <StagesDropdown />
            </div>
            <div style={{ width: filterWidth }}>
              <LevelDropdown />
            </div>
            <div style={{ width: filterWidth }}>
              <CategoryDropdown />
            </div>
            <div style={{ width: filterWidth }}>
              <ProtocolDropdown />
            </div>
            <div style={{ width: filterWidth }}>
              <AnnexesDropdown />
            </div>
            <InfoTooltip message={'filters message'} />
            <div>
              <Divider className="divider mr-4" variant="middle" orientation="vertical" />
            </div>
          </div>
          <div>
            <RefreshButton />
          </div>
        </div>
      </Slide>

      {(!popUpMessage.show && !popUpMenu.show) &&
        <div className={itemsSwitch ? 'customcard-types-buttons-layout filters-right' : 'customcard-types-buttons-layout'}>
          {customcardTypes.map(({ title, icon }) => (
            <CustomCardTypesButton
              key={title}
              title={title}
              icon={icon}
              disabled={!userActiveModules.includes(title)}
              selected={activeCustomcardTypes.includes(title)}
              onClick={() => {
                if (userActiveModules.includes(title)){
                  handleCustomcardTypeChange(title);
                }
              }}
            />
          ))}
        </div>
      }
    </div>
  );
}

export default FiltersSet;